<template>
  <div class="row">
    <header-servico
      tipo="Atividade"
      :familia="familia.id"
      :loading="loading"
    />
    <load v-if="loading" message="Carregando Atividades relacionadas a Família" />
    <div v-else class="col-md-12">
      <!--Tabela-->
      <div class="row">
        <sidebar-servicos active="atividade" />
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12">
              <header-familia :item="familia" />
            </div>
          </div>
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div
               
                  class="animate__animated animate__fadeIn"
                >
                <div class="row">
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-end mb-4">
        

              <div>
                <b-button-group>
                  <b-button
                    variant="outline-dark"
                    :class="viewFilterReport === true ? 'active' : ''"
                    @click="viewFilters"
                  >
                    <i class="fas fa-filter"></i>
                    {{ $t("Filtros") }}
                  </b-button>
                  <b-button variant="outline-dark" @click="print()">
                    <i class="fas fa-print"></i>
                  </b-button>
                  <b-button
                    variant="outline-dark"
                    @click="exportar()"
                    :title="$t('Exportar')"
                    v-b-tooltip.hover
                  >
                    <i class="fas fa-file-excel"></i>
                  </b-button>
                </b-button-group>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="viewFilterReport">
            <!-- Filtros -->
            <form @submit.prevent="getAtividades" >
              <div class="row">
                <form-calendar
                  v-model="data_inicio"
                  grid="3"
                  label="Data inicial"
                  :max-date="dataNow"
                />

                <form-calendar
                  v-model="data_fim"
                  grid="3"
                  label="Data final"
                  :required="verificaDataInicial"
                  :min-date="data_inicio"
                  :max-date="dataNow"
                />

                <form-select
                  v-model="filtroStatus"
                  grid="6"
                  label="Status"
                  :itens="status"
                  :loading="loadingStatus"
                  :disabled="loadingStatus"
                  multiple
                />

                <form-select
                  v-model="filtroTipos"
                  label="Filtrar por Tipo"
                  grid="12"
                  :itens="tipos"
                  :disabled="loadingSearchTipos"
                  :loading="loadingSearchTipos"
                  :multiple="true"
                />

                <div class="col-md-12">
                  <label><b>Pesquisar</b></label>
                  <div class="input-group">
                    <b-input
                      placeholder="No campo acima você pode pesquisar por: No campo acima você pode pesquisar por: Título ou Tema"
                      class="form-control search-input"
                      type="text"
                      v-model="search"
                      aria-describedby="input-search"
                      @keydown.enter.prevent="getAnalytics"
                    />
                  </div>
                  <p class="small text-muted">
                    No campo acima você pode pesquisar por: Título ou Tema.
                  </p>
                </div>
              </div>
              <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
                <div class="col-auto px-2 text-right">
                  <button
                    class="btn btn-default"
                    @click.prevent="limparFiltros(), (viewFilterReport = false)"
                  >
                    <i class="fas fa-times"></i>
                  </button>

                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click.prevent="limparFiltros()"
                  >
                    {{ $t("Limpar Filtros") }}
                  </button>

                  <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    type="submit"
                  >
                    <i class="fas fa-chart-bar"></i>
                    {{ $t("Gerar Relatório") }}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-12">
            <loading-animation
              :active.sync="loading"
              :is-full-page="false"
              :opacity="1"
              color="#5895FF"
            />
            <print-content>
              <b-table
                :fields="[
                  {
                    key: 'titulo',
                    label: $t('Detalhes'),
                  },
                  {
                    key: 'data',
                    label: $t('Data e Hora'),
                  }, 
                  {
                    key: 'inscritos',
                    label: $t('Familiares na atividade'),
                  },
                  {
                    key: 'status',
                    label: $t('Status'),
                  },
                  {
                    key: 'actions',
                    label: '',
                    class: 'text-right no-print',
                    thStyle: {
                      width: '95px',
                      minWidth: '95px',
                    },
                  },
                ]"
                :items="ItemList"
                :responsive="true"
                striped
                hover
                show-empty
                small
                outlined
                stacked="xs"
                table-class="mb-3"
              >
                <template v-slot:cell(titulo)="data">
                  Tipo:
                  <strong>
                    {{ data.item.tipo }}
                  </strong>
                  <br />
                  Título:
                  <strong> {{ data.value }} </strong>
                  <br />
                  Técnico autor:
                  <strong>
                    {{ data.item.autor }} 
                  </strong>
                  <br />
                  Protocolo:
                  <strong> {{ data.item.protocolo }} </strong>
                </template>
                <template v-slot:cell(inscritos)="data">
           
                  <span v-for="inscrito in data.item.inscritos" :key="inscrito.id">
                 
                  <span v-if="familia.id == inscrito.reportusuario.familia_id">
                    <span class="badge badge-light">{{ inscrito.reportusuario.nome_completo }}</span>
                  </span>  
                </span>
                </template>   
                
                <template v-slot:cell(data)="data">
                  <strong>{{ data.value | formatDate() }}</strong>
                  <strong>{{ data.item.hora_print }}</strong>
                </template>
                <template v-slot:cell(status)="data">
                  <span v-html="data.item.status_nome"></span>
                </template>

                <template v-slot:cell()="data">
                  <b-button
                    :title="$t('Editar')"
                    :to="'/dashboard/atividades/edit/' + data.item.id"
                    class="px-2 mb-0"
                    size="xs"
                    type="button"
                    v-b-tooltip.hover
                    variant="success"
                    v-if="
                      verifyEditPermission(
                        data.item.user_id,
                        data.item.responsavel.id,
                        data.item.participantes_array
                      )
                    "
                  >
                    <i class="mdi mdi-square-edit-outline" />
                  </b-button>

                  <b-button
                    :title="$t('Visualizar e Imprimir')"
                    :to="'/dashboard/atividades/show/' + data.item.id"
                    class="px-2 mb-0"
                    size="xs"
                    type="button"
                    v-b-tooltip.hover
                    variant="primary"
                    v-else
                  >
                    <i class="mdi mdi-eye" />
                  </b-button>
                </template>
                <template v-slot:empty="scope">
                  <div class="text-center my-5">
                    <img
                      :alt="$t('No results')"
                      class="mb-5"
                      src="/img/icons/robot.svg"
                      style="max-height: 165px"
                    />
                    <h3 class="bold">
                      {{ $t("No records found") }}
                    </h3>
                  </div>
                </template>
              </b-table>
            </print-content>
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-12">
                <div class="form-group d-inline-flex mb-0">
                  <select
                    class="form-control"
                    style="width: 70px"
                    v-model="perPage"
                    v-on:change="getAtividades"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                </div>
                <div class="d-inline-flex ml-2">
                  <b-pagination
                    :per-page="perPage"
                    :total-rows="pagination.total"
                    @change="changePage"
                    v-model="page"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                <div class="float-lg-right">
                  {{ $t("Showing page") }}
                  {{ pagination.currentPage }}
                  {{ $t("of") }}
                  {{ pagination.totalPages }}
                  {{ $t("pages in") }}
                  {{ pagination.total }}
                  {{ $t("records") }}
                </div>
              </div>
            </div>
          </div>
          <router-view />
        </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Atividades",
  metaInfo() {
    return {
      title: this.$i18n.t("Atividades"),
    };
  },
  data() {
    return {
      familia: {},
      novo_atendimento: false,
      TipoItemList: [],
      ItemList: [],
      page: 1,
      search: "",
      perPage: 10,
      loadingAtividades: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      user_id: null,
      tecnico_id: null,
      unidade_id: null,
      filtroStatus: null,
      filtroDatas: [],
      status: [],
      filtroFamiliar: null,
      familiares: [],
      filtroDatasAt: [],
      dataNowAt: moment().format("YYYY-MM-DD"),
      filtrarDatas: false,
      showTecnicos: false,
      data_fim_at: "",
      data_inicio_at: "",
      data_inicio: "",
      data_fim: "",
      tipos: "",
    };
  },
  mounted() {
    this.$route.query.familia_id = this.$route.params.id;
    if (typeof this.$route.query.item === "object") {
      this.familia = this.$route.query.item;
    } else {
      this.getFamilia();
    }
    this.getStatus();   
     this.getTipos();
    this.getAtividades();
  },
  methods: {
    filterData(value) {
      return this.$options.filters.formatDateHora(value);
    }, 
     getTipos() {
      this.loadingSearchTipos = true;
      axios
        .get(`api/dashboard/report/atividades/tipos`)
        .then((response) => {
          this.tipos = response.data;
        })
        .finally(() => (this.loadingSearchTipos = false));
    },
    getAtividades() {
      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      this.filtroDatasAt = [];
      if (this.data_inicio_at) {
        this.filtroDatasAt.push(
          this.$options.filters.formatDateYMD(this.data_inicio_at)
        );
      }
      if (this.data_fim_at) {
        this.filtroDatasAt.push(
          this.$options.filters.formatDateYMD(this.data_fim_at)
        );
      }

      this.loadingAtividades = true;
      axios
        .get("api/dashboard/atividades/familia", {
          params: {
            familia_id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroDatas: this.filtroDatas,
            filtroStatus: this.filtroStatus,
            filtroTipos: this.filtroTipos,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.tecnico_id = this.$store.state.user.tecnico.id;
          this.unidade_id = this.$store.state.user.tecnico.unidade_id;
          this.ItemList = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getAtividades();
          } else {
            this.loadingAtividades = false;
          }
        })
        .catch(() => {
          this.loadingAtividades = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      this.filtroDatasAt = [];
      if (this.data_inicio_at) {
        this.filtroDatasAt.push(
          this.$options.filters.formatDateYMD(this.data_inicio_at)
        );
      }
      if (this.data_fim_at) {
        this.filtroDatasAt.push(
          this.$options.filters.formatDateYMD(this.data_fim_at)
        );
      }
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/atividades/familia", {
          params: {
            familia_id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroDatasAt: this.filtroDatasAt,
            filtroFamiliar: this.filtroFamiliar,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getAtividades();
      }
    },
    redirectAtendimento(id) {
      this.$router.push({
        path: `/dashboard/atendimentos/edit/${id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    getFamilia() {
      axios
        .get("api/dashboard/familias/" + this.$route.params.id)
        .then((response) => {
          this.familia = response.data.data;

          this.familiares = this.familia.familiares.map((elem) => ({
            id: elem.id,
            value: elem.nome_completo,
          }));

          this.$route.query.familia_id = this.familia.id;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
    getStatus() {
      axios.get(`api/dashboard/status/atendimento`).then((response) => {
        this.status = response.data;
      });
    },
    limparFiltros() {
      this.search = "";
      this.filtroStatus = null;
      this.filtroTipos = null;
      this.filtroDatas = [];
      this.data_inicio = "";
      this.data_fim = "";
      this.data_inicio_at = "";
      this.data_fim_at = "";

      this.filtroDatasAt = [];

      this.verificaDataInicialAt = false;
      this.getAtividades();
    }, 
    verifyEditPermission(user, tecnico, participantes) {
      const tecnicoInscrito = participantes.filter((id) => {
        return id === this.tecnico_id;
      });

      return tecnicoInscrito.length > 0 || this.user_id == user ? true : false;
    },
  },
};
</script>
